export default "__VITE_ASSET__CwvSTSsr__"